export interface TierRemaining {
  creditsRemaining: number
  nightsRemaining: number
}

/**
 * Calculates how many status credits and nights remain to reach
 * (or retain) a target tier.
 *
 * @param mode - 'upgrade' for progressing to the next tier,
 *               'retain' for keeping the current tier (platinum only).
 */
export default function calculateTierRemaining(
  account: App.LoyaltyAccount,
  mode: 'upgrade' | 'retain' = 'upgrade',
): TierRemaining {
  const statusCredits = account.statusCredits ?? 0
  const numberOfNights = account.numberOfNights ?? 0

  const creditTarget = mode === 'retain'
    ? (account.totalCreditsForTierRetention ?? 0)
    : (account.totalCreditsForTierUpgrade ?? 0)
  const nightTarget = mode === 'retain'
    ? (account.numberOfNightsForTierRetention ?? 0)
    : (account.numberOfNightsForTierUpgrade ?? 0)

  return {
    creditsRemaining: Math.max(0, creditTarget - statusCredits),
    nightsRemaining: Math.max(0, nightTarget - numberOfNights),
  }
}
